import { render, staticRenderFns } from "./itemWrapper.vue?vue&type=template&id=40d310f8&scoped=true&"
import script from "./itemWrapper.vue?vue&type=script&lang=js&"
export * from "./itemWrapper.vue?vue&type=script&lang=js&"
import style0 from "./itemWrapper.vue?vue&type=style&index=0&id=40d310f8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d310f8",
  null
  
)

export default component.exports